__turbopack_context__.v({
  "calloutSection": "PlasmicPrivacyPolicy-module__Le15uq__calloutSection",
  "contactModal": "PlasmicPrivacyPolicy-module__Le15uq__contactModal",
  "footer": "PlasmicPrivacyPolicy-module__Le15uq__footer",
  "header": "PlasmicPrivacyPolicy-module__Le15uq__header",
  "privacyPolicyBanner": "PlasmicPrivacyPolicy-module__Le15uq__privacyPolicyBanner",
  "root": "PlasmicPrivacyPolicy-module__Le15uq__root",
});
